// extracted by mini-css-extract-plugin
export default {"card":"CommonComponents_card__4LnE2"};